import React from 'react';
import { SEOHead } from '@/components/SEOHead';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface SEOLayoutProps {
  title: string;
  description: string;
  keywords: string;
  children: React.ReactNode;
  datePublished?: string;
  dateModified?: string;
}

export const SEOLayout: React.FC<SEOLayoutProps> = ({ title, description, keywords, children, datePublished, dateModified }) => (
  <div className="min-h-screen bg-background">
    <SEOHead
      title={title}
      description={description}
      keywords={keywords}
      schemaType="Article"
      datePublished={datePublished || '2026-01-15'}
      dateModified={dateModified}
    />
    <header className="border-b border-border bg-background sticky top-0 z-50">
      <div className="container mx-auto px-4 py-4">
        <Link to="/" className="inline-flex items-center gap-2 text-muted-foreground hover:text-foreground transition-colors text-sm">
          <ArrowLeft className="w-4 h-4" /> Back to Home
        </Link>
      </div>
    </header>
    <main className="container mx-auto px-4 py-12 max-w-3xl">
      {children}
    </main>
    <footer className="border-t border-border py-8">
      <div className="container mx-auto px-4 text-center text-sm text-muted-foreground">
        <p>© {new Date().getFullYear()} Vergo. Find your perfect AI companion.</p>
        <div className="flex justify-center gap-4 mt-2">
          <Link to="/" className="hover:text-foreground transition-colors">Home</Link>
          <Link to="/compare" className="hover:text-foreground transition-colors">Compare Tools</Link>
          <Link to="/how-we-review" className="hover:text-foreground transition-colors">How We Review</Link>
        </div>
      </div>
    </footer>
  </div>
);
